import { useWorkflow } from '../context/WorkflowContext';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const RootfiSyncNode = (props: TNodeProps) => {
  const { workflow } = useWorkflow();
  const { data } = props;
  const canAddOutgoing = !workflow?.stepTransitions?.some(
    (transition) => transition.fromStepId === data.id
  );

  return (
    <BaseNode {...props} className="min-w-80">
      <StandardHandles
        withReverseVerticals
        isSourceConnectable={canAddOutgoing}
      />
    </BaseNode>
  );
};
